"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNormalizeConfig = void 0;
function getNormalizeConfig(mapping) {
    const config = new Map();
    for (const [source, options] of Object.entries(mapping)) {
        let target;
        let nativeStyleToProp;
        if (!options)
            continue;
        if (typeof options === "boolean") {
            target = source;
        }
        else if (typeof options === "string") {
            target = options;
        }
        else {
            target = typeof options.target === "boolean" ? source : options.target;
            nativeStyleToProp = options.nativeStyleToProp;
        }
        config.set(target, { target, source, nativeStyleToProp });
    }
    return Array.from(config.values());
}
exports.getNormalizeConfig = getNormalizeConfig;
//# sourceMappingURL=config.js.map